import { inject, injectable } from "@launchtray/tsyringe-async";
import { PromiseCompletionSource } from "async/PromiseCompletionSource";
import { ICanvasScaler } from "by/gamefactory/canvas/ICanvasScaler";
import { Viewable } from "by/gamefactory/scene/viewable/Viewable";
import { WarningMessagePopupView } from "./view/WarningMessagePopupView";
import { EditPriceWarningResourcePackage } from "./resources/EditPriceWarningResourcePackage";

@injectable()
export class WarningMessagePopupScene extends Viewable<boolean> {
    public constructor(
        resources: EditPriceWarningResourcePackage,
        @inject("ICanvasScaler") canvasScaler: ICanvasScaler
    ) {
        super();
        const pcs = new PromiseCompletionSource<boolean>();
        this.view = new WarningMessagePopupView(
            pcs,
            resources,
            canvasScaler
        );
        pcs.result.then((result) => {
            this.operationControls.complete(result);
        }, (reason: unknown) => {
            this.operationControls.error(reason);
        });
    }
}
